import React from 'react';
import PropTypes from 'prop-types';
import FontAwesomeIcon from '@fortawesome/react-fontawesome';

import { metricsStyleSelector, getChangeType } from 'utils/metricesHelper';

const Comparison = ({ comparisonInterval, changeValue }) => {
  const changeType = getChangeType(changeValue);
  const comparisonIcon = metricsStyleSelector(changeType, changeValue);
  const { icon, fontClass } = comparisonIcon;
  const className = `${fontClass} font-weight-bold`;
  const noChange = changeType === 'constant';
  const changeText = noChange ? '' : `${changeValue.toString().replace('-', '')}`;

  return (
    <div className="metrics-comparision">
      <FontAwesomeIcon className={'dash-svg ' + className} icon={icon} />
      <span className={'dash-span ' + className}>
        {changeText}
        {' '}
      </span>
      {!noChange ? `from ${comparisonInterval}` : 'No change'}
    </div>
  );
};

Comparison.propTypes = {
  comparisonInterval: PropTypes.string,
  changeValue: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
};

Comparison.defaultProps = {
  changeValue: 0,
  comparisonInterval: '',
};

export default Comparison;



// WEBPACK FOOTER //
// ./src/components/dashboard/number/Comparison.js